module.exports = __webpack_public_path__ + "img/logo2.b836b29a.png";